import { render, staticRenderFns } from "./marketplacePortal.vue?vue&type=template&id=e286b4ec&scoped=true&"
import script from "./marketplacePortal.vue?vue&type=script&lang=js&"
export * from "./marketplacePortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e286b4ec",
  null
  
)

export default component.exports